import { fetchGet, fetchPost } from 'common';

const apiUri: string = process.env.REACT_APP_API_URI as string;

// TODO ?expires=Date.Now() is to prevent caching of the API result in IE11 which leads to unwanted behavior. There might be a better way to handle this.
export const fetchStatesService = (bearerToken: string) =>
  fetchGet(`${apiUri}/taxtrax/getstates?expires=${Date.now()}`, bearerToken);

// TODO ?expires=Date.Now() is to prevent caching of the API result in IE11 which leads to unwanted behavior. There might be a better way to handle this.
export const fetchAvailableMunicipalitiesService = (bearerToken: string) =>
  fetchGet(
    `${apiUri}/taxtrax/getavailablemunicipalities?expires=${Date.now()}`,
    bearerToken,
  );

export const fetchDriversService = (hobCode: string, bearerToken: string) =>
  fetchGet(`${apiUri}/dictionaries/drivers/${hobCode}`, bearerToken);

export const searchByAddressService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/taxtrax/searchByAddress`, body, bearerToken);

export const searchByOwnerService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/taxtrax/searchByOwner`, body, bearerToken);

export const searchByDriversService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/taxtrax/searchByDrivers`, body, bearerToken);
